import { API as MOCK_AMPLIFY_API } from "../../__mocks__/aws-amplify";
import { API as AMPLIFY_API } from "aws-amplify";
import {
  createSampleBatchMutation,
  createCryoboxMutation,
  updateCryoboxMutation,
} from "../graphql/mutations";
import {
  findCryoboxesQuery,
  findSampleBatchesQuery,
  getSampleBatchQuery,
  getCryoboxQuery,
  listFreezersQuery,
} from "../graphql/queries";
import {
  CreateCryoBoxInput,
  CreateSampleBatchInput,
  UpdateCryoBoxInput,
} from "./lab.types";

let API =
  process.env.REACT_APP_USE_MOCKS === "true" ? MOCK_AMPLIFY_API : AMPLIFY_API;

const participantApi = {
  getSampleBatch: async (batchID: string): Promise<any> => {
    try {
      return await API.graphql({
        query: getSampleBatchQuery,
        variables: {
          batchID,
        },
      });
    } catch (error) {
      return error;
    }
  },
  findSampleBatches: async (searchTerm: string): Promise<any> => {
    try {
      return await API.graphql({
        query: findSampleBatchesQuery,
        variables: {
          searchTerm,
        },
      });
    } catch (error) {
      return error;
    }
  },
  createSampleBatch: async (inputs: CreateSampleBatchInput): Promise<any> => {
    try {
      return await API.graphql({
        query: createSampleBatchMutation,
        variables: {
          input: inputs,
        },
      });
    } catch (error) {
      return error;
    }
  },
  getCryobox: async (serialNo: string): Promise<any> => {
    try {
      return await API.graphql({
        query: getCryoboxQuery,
        variables: {
          serialNo,
        },
      });
    } catch (error) {
      return error;
    }
  },
  findCryoboxes: async (
    searchTerm: string,
    freezerId: string,
    bioBanked: string
  ): Promise<any> => {
    try {
      return await API.graphql({
        query: findCryoboxesQuery,
        variables: {
          bioBanked: bioBanked === "true",
          freezerId,
          searchTerm,
        },
      });
    } catch (error) {
      return error;
    }
  },
  createCryoBox: async (values: CreateCryoBoxInput): Promise<any> => {
    try {
      return await API.graphql({
        query: createCryoboxMutation,
        variables: {
          input: {
            serialNo: values.serialNo,
            height: parseInt(values.height),
            width: parseInt(values.width),
            sampleType: values.sampleType,
            aliquotPositions: values.aliquotPositions,
            bioBanked: false,
            freezerId: values.freezerId,
            freezerShelfNo: values.freezerShelfNo,
            shelfRackNo: values.shelfRackNo,
            rackPositionNo: values.rackPositionNo,
          },
        },
      });
    } catch (error) {
      return error;
    }
  },
  updateCryobox: async (values: UpdateCryoBoxInput): Promise<any> => {
    try {
      return await API.graphql({
        query: updateCryoboxMutation,
        variables: {
          input: {
            serialNo: values.serialNo,
            aliquotPositions: values.aliquotPositions,
            freezerId: values.freezerId,
            freezerShelfNo: values.freezerShelfNo,
            shelfRackNo: values.shelfRackNo,
            rackPositionNo: values.rackPositionNo,
            bioBanked: values.bioBanked,
          },
        },
      });
    } catch (error) {
      return error;
    }
  },
  listFreezers: async (): Promise<any> => {
    try {
      return await API.graphql({
        query: listFreezersQuery,
      });
    } catch (error) {
      console.log(error);
      return error;
    }
  },
};

export default participantApi;
